/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionDifference {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionDifference.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionDifference>): AppSecopsSbomVersionDifference {
        let obj = Object.assign(new AppSecopsSbomVersionDifference(), model);
        AppSecopsSbomVersionDifference.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionDifference>): AppSecopsSbomVersionDifference {
        if (!model) return null;
        return AppSecopsSbomVersionDifference.newInstance(<AppSecopsSbomVersionDifference> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionDifference) {
        if (!obj) return;

        models.AppSecopsSbomVersionDifference.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionDifference): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVersionDifference.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the SBOM version to compare against
     */
    base_version_id: string;

    /**
     * ID of the SBOM version to compare with
     */
    compare_version_id: string;

    /**
     * List of new component IDs created in the SBOM version
     */
    new_component_ids: Array<string>;

    /**
     * List of upgraded component IDs created in the SBOM version
     */
    upgraded_component_ids: Array<string>;

    /**
     * List of deleted component IDs in the SBOM version
     */
    deleted_component_ids: Array<string>;

    /**
     * List of new vulnerability IDs created in the SBOM version
     */
    new_vulnerability_ids: Array<string>;

    /**
     * List of resolved vulnerability IDs in the SBOM version
     */
    resolved_vulnerability_ids: Array<string>;

}
